import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { LogOut, ShieldCheck, User as UserIcon } from 'lucide-react';
import AdminPanel from './AdminPanel';

const LOGO_URL = '/logo.png';

const Header = () => {
  const { user, isAdmin, logout } = useAuth();
  const [adminOpen, setAdminOpen] = useState(false);

  return (
    <>
      <header
        className="w-full border-b border-white/[0.08] bg-[#050505]/90 backdrop-blur-md sticky top-0 z-40"
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between gap-4">
          <a
            href="https://gracethegeekstudios.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group shrink-0"
            data-testid="header-logo-link"
          >
            <img
              src={LOGO_URL}
              alt="Grace The Geek Studios"
              className="h-10 sm:h-11 w-auto object-contain group-hover:opacity-80 transition-opacity"
              data-testid="company-logo"
            />
          </a>

          <div className="flex items-center gap-3">
            <span className="hidden md:inline font-mono text-xs uppercase tracking-[0.35em] text-zinc-500">
              // world_time.exe
            </span>

            {user && typeof user === 'object' && (
              <div className="flex items-center gap-2">
                <div
                  className={`hidden sm:flex items-center gap-2 px-3 py-2 border ${
                    isAdmin
                      ? 'border-[#735AE2]/40 bg-[#735AE2]/10'
                      : 'border-white/[0.12] bg-white/[0.02]'
                  }`}
                  data-testid="user-badge"
                >
                  <UserIcon className={`w-3.5 h-3.5 ${isAdmin ? 'text-[#735AE2]' : 'text-zinc-400'}`} />
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">
                    {user.name || user.email.split('@')[0]}
                  </span>
                  <span
                    className={`font-mono text-[9px] uppercase tracking-[0.2em] ${
                      isAdmin ? 'text-[#9D8AEC]' : 'text-zinc-500'
                    }`}
                  >
                    · {user.role}
                  </span>
                </div>

                {isAdmin && (
                  <button
                    onClick={() => setAdminOpen(true)}
                    data-testid="admin-panel-btn"
                    className="flex items-center gap-1.5 px-3 py-2 border border-[#735AE2]/40 bg-transparent text-[#9D8AEC] hover:bg-[#735AE2]/10 hover:text-white font-mono text-[10px] uppercase tracking-[0.25em] font-medium transition-colors"
                    title="Admin panel"
                  >
                    <ShieldCheck className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">Admin</span>
                  </button>
                )}

                <button
                  onClick={logout}
                  data-testid="logout-btn"
                  className="flex items-center gap-1.5 px-3 py-2 border border-white/[0.15] bg-transparent text-zinc-400 hover:bg-white/[0.05] hover:text-white font-mono text-[10px] uppercase tracking-[0.25em] font-medium transition-colors"
                  title="Sign out"
                >
                  <LogOut className="w-3.5 h-3.5" />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {isAdmin && <AdminPanel open={adminOpen} onClose={() => setAdminOpen(false)} />}
    </>
  );
};

export default Header;
